/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SESSION_TYPES } from 'libs/services/live-stream';

/**
 * This components shows the session type selector buttons
 *
 * @typedef {String} SessionTypeValue
 *
 * @category ui.components.session-type
 * @exports SessionType
 */
const __vue_script__ = {
    name: 'SessionType',

    props: {
        initialValue: {
            type: String,
            default: ''
        },

        readonly: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            sessionTypeOptions: [
                {
                    label: this.$i18n.t('live_sessions.form.sessions.virtual'),
                    description: this.$i18n.t('live_sessions.form.sessions.virtual_description'),
                    icons: ['ic-remote'],
                    value: SESSION_TYPES.VIRTUAL
                },
                {
                    label: this.$i18n.t('live_sessions.form.sessions.in_person'),
                    description: this.$i18n.t('live_sessions.form.sessions.in_person_description'),
                    icons: ['ic-in-person'],
                    value: SESSION_TYPES.IN_PERSON
                },
                {
                    label: this.$i18n.t('live_sessions.form.sessions.hybrid'),
                    description: this.$i18n.t('live_sessions.form.sessions.hybrid_description'),
                    icons: ['ic-remote', 'ic-in-person'],
                    value: SESSION_TYPES.HYBRID
                }
            ],
            sessionType: this.initialValue || '',
            selectedBadge: {
                label: this.$i18n.t('live_sessions.form.sessions.virtual'),
                description: this.$i18n.t('live_sessions.form.sessions.virtual_description'),
                icons: ['ic-remote'],
                value: SESSION_TYPES.VIRTUAL
            }
        };
    },

    async created() {
        this.selectedBadge = this.sessionTypeOptions.filter(option => option.value === this.initialValue)[0];
    },

    methods: {
        setSessionType(event, type) {
            if (event.detail === 0 || event.code === 'Enter') {
                return;
            }

            this.sessionType = type;
            this.$emit('change', type);
        },

        keyEvent(event, type) {
            if (event.code === 'Enter') {
                return;
            } else if (event.code === 'Space') {
                this.setSessionType({
                    detail: 1
                }, type);
            }
        }
    }
};


/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session-type"},[(!_vm.readonly)?_c('div',{staticClass:"form"},[_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.$t('live_sessions.form.session_type')))]),_c('div',{staticClass:"control-hint"},[_vm._v(_vm._s(_vm.$t('live_sessions.form.unchangeable_type')))]),_c('div',{staticClass:"session-type-buttons"},_vm._l((_vm.sessionTypeOptions),function(bt){
var _obj;
return _c('button',{key:bt.value,class:( _obj = { 'active' : _vm.sessionType === bt.value }, _obj[("session-type-" + (bt.value.toLowerCase()))] = true, _obj ),attrs:{"name":"session_type"},on:{"click":function($event){$event.preventDefault();return (function (event) { return _vm.setSessionType(event, bt.value); }).apply(null, arguments)},"keydown":function (event) { return _vm.keyEvent(event, bt.value); }}},[_vm._l((bt.icons),function(icon){return _c('i',{key:icon,staticClass:"icon",class:icon})}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(bt.label))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(bt.description))])],2)}),0)]):_vm._e(),(_vm.readonly)?_c('div',{staticClass:"session-type-badge"},[_vm._l((_vm.selectedBadge.icons),function(icon){return _c('i',{key:icon,staticClass:"icon",class:icon})}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.selectedBadge.label))])],2):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionType.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__